<template>
  <figure class="return-image">
    <div class="circle">
      <CloudLeft class="cloud-left" />
      <CloudRight class="cloud-right" />
      <component :is="activeIllustration" />
    </div>
  </figure>
</template>

<script>
import { OrderZero, ReturnOne, ReturnTwo, ReturnThree, ReturnFour, ReturnFive, ReturnBus, ReturnBusPlus, ReturnBoat, CloudLeft, CloudRight } from './icons'
export default {
  name: 'ReturnImage',
  props: {
    amount: {
      type: Number,
      default: 3
    }
  },
  computed: {
    activeIllustration () {
      if (this.amount > 15) {
        return ReturnBoat
      }
      if (this.amount > 10) {
        return ReturnBusPlus
      }
      if (this.amount > 5) {
        return ReturnBus
      }
      if (this.amount > 4) {
        return ReturnFive
      }
      if (this.amount > 3) {
        return ReturnFour
      }
      if (this.amount > 2) {
        return ReturnThree
      }
      if (this.amount > 1) {
        return ReturnTwo
      }
      if (this.amount > 0) {
        return ReturnOne
      }
      return OrderZero
    }
  },
  components: {
    CloudLeft,
    CloudRight
  }
}
</script>

<style lang="scss" scoped>
.return-image {
  display: block;
  margin: 0;
  text-align: center;
}

.circle {
  width: 195px;
  height: 195px;
  border-radius: 50%;
  background-color: #015151;
  position: relative;
  margin: 0 auto;
}

@keyframes clouds {
  from,
  to {
    transform: scale(1);
  }
  50% {
    transform: scale(0.95);
  }
}

.cloud-left,
.cloud-right {
  position: absolute;
  fill: #1F7F8D;
  z-index: 1;
}

.cloud-left {
  left: -41px;
  top: 22px;
  animation: clouds 2s linear infinite;
}

.cloud-right {
  top: 20px;
  left: 132px;
  animation: clouds 3s linear infinite;
}
</style>
